<button
  class="sis-button"
  [class.sis-button--primary]="variant === 'primary'"
  [class.sis-button--secondary]="variant === 'secondary'"
  [class.sis-button--ghost]="variant === 'ghost'"
  [class.sis-button--block]="block"
  [type]="type"
  [disabled]="disabled"
  [attr.aria-label]="ariaLabel"
  (click)="onClick($event)">
  <ng-content></ng-content>
</button>
